import { Box, Typography } from '@mui/material';

import colors from 'common/constants/colors';
import { normalizePhoneNumber } from 'common/utils';

import PlaceholderEmailMarker from './PlaceholderEmailMarker';
import partnerContactPropType from './partnerContactPropType';

const contactLineSx = { display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, height: 20 };
// A word, not an icon, so the line reads as the patient's email / phone rather than the partner's.
const contactLabelSx = { width: 40, flexShrink: 0, color: 'text.secondary' };

const PartnerContactListItem = ({ partnerContact }) => {
  const { partnerName, email, phoneNumber, hasPlaceholderEmail } = partnerContact;
  const displayedPhoneNumber = normalizePhoneNumber(phoneNumber);

  return (
    <Box
      role='listitem'
      sx={{
        py: 1,
        '&:not(:last-of-type)': { borderBottom: `1px solid ${colors.subtleDivider}` },
      }}
    >
      <Typography variant='body2' noWrap title={partnerName} sx={{ fontWeight: 500, mb: 0.75 }}>
        {partnerName}
      </Typography>

      <Box sx={contactLineSx}>
        <Typography variant='caption' aria-hidden sx={contactLabelSx}>
          Email
        </Typography>
        <Typography
          variant='body2'
          noWrap
          title={email}
          aria-label={email ? `Email ${email}` : 'No email'}
          sx={{ color: email ? 'text.primary' : 'text.secondary' }}
        >
          {email || '—'}
        </Typography>
        {hasPlaceholderEmail && <PlaceholderEmailMarker sx={{ ml: 'auto' }} />}
      </Box>

      <Box sx={contactLineSx}>
        <Typography variant='caption' aria-hidden sx={contactLabelSx}>
          Phone
        </Typography>
        <Typography
          variant='body2'
          noWrap
          aria-label={displayedPhoneNumber ? `Phone ${displayedPhoneNumber}` : 'No phone'}
          sx={{ color: displayedPhoneNumber ? 'text.primary' : 'text.secondary' }}
        >
          {displayedPhoneNumber || '—'}
        </Typography>
      </Box>
    </Box>
  );
};

PartnerContactListItem.propTypes = {
  partnerContact: partnerContactPropType.isRequired,
};

export default PartnerContactListItem;
